import {
  SEND_LOG_IN_REQUEST,
  RECEIVE_LOG_IN_RESPONSE,
  LOG_OUT,
  CHECK_LOCAL_STORAGE_LOGIN,
  CHANGE_NAME,
  CHANGE_AVATAR
} from './authorizationActions'

const initialState = {
  isLogInPending: false,
  personId: undefined,
  userId: undefined,
  email: undefined,
  name: undefined,
  loginError: undefined,
  avatar: undefined
}

export default (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SEND_LOG_IN_REQUEST:
      return { ...initialState, isLogInPending: true }

    case RECEIVE_LOG_IN_RESPONSE:
      if (!action.email) {
        return { ...initialState, loginError: 'unmatching user' }
      }

      localStorage.setItem('personId', action.personId)
      localStorage.setItem('userId', action.userId)
      localStorage.setItem('email', action.email)
      localStorage.setItem('name', action.name)
      localStorage.setItem('avatar', action.avatar)

      return {
        isLogInPending: false,
        personId: action.personId,
        userId: action.userId,
        email: action.email,
        name: action.name,
        avatar: action.avatar
      }

    case LOG_OUT:
      localStorage.removeItem('personId')
      localStorage.removeItem('userId')
      localStorage.removeItem('email')
      localStorage.removeItem('name')
      localStorage.removeItem('avatar')

      return { ...initialState }

    case CHECK_LOCAL_STORAGE_LOGIN:
      if (action.userId && action.email && action.name) {
        return {
          isLogInPending: false,
          personId: action.personId,
          userId: action.userId,
          email: action.email,
          name: action.name,
          avatar: action.avatar
        }
      }
      return state

    case CHANGE_NAME:
      localStorage.setItem('name', action.payload.name)
      return {
        ...state,
        name: action.payload.name
      }
    case CHANGE_AVATAR:
      localStorage.setItem('avatar', action.payload.avatar)
      return {
        ...state,
        avatar: action.payload.avatar
      }
    default: return state
  }
}
